module.exports = __webpack_public_path__ + "img/icon-help.f0d2fe81.svg";